import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import Button from "../elements/Button";
import { t } from "i18next";

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const heroRef = useRef(null);
  const scrollWrapperRef = useRef(null);
  
  const INITIAL_OFFSET = -120;
  const BOTTOM_BUFFER = 100; 
  const SCROLL_SPEED = 0.6;  
  const SMOOTHING = 0.1;    
  const LAPTOP_BREAKPOINT = 1024; 

  const state = useRef({
    targetY: 0,
    currentY: 0,
    maxTranslate: 0,
    requestRef: null,
    isDesktop: false,
  });

  useEffect(() => {
    const updateDimensions = () => {
      const isDesktop = window.innerWidth >= LAPTOP_BREAKPOINT;
      state.current.isDesktop = isDesktop;

      if (heroRef.current && scrollWrapperRef.current) {
        if (isDesktop) {
          const heroHeight = heroRef.current.offsetHeight;
          const contentHeight = scrollWrapperRef.current.offsetHeight;
          const availableSpace = (heroHeight - contentHeight) / 2 - BOTTOM_BUFFER + INITIAL_OFFSET;
          state.current.maxTranslate = Math.max(0, availableSpace);
        } else {
          state.current.currentY = 0;
          state.current.targetY = 0;
          scrollWrapperRef.current.style.transform = `translate3d(0, ${INITIAL_OFFSET}px, 0)`;
        }
      }
    };

    const handleScroll = () => {
      if (!state.current.isDesktop) return;
      const scrollTop = window.scrollY;
      state.current.targetY = Math.min(scrollTop * SCROLL_SPEED, state.current.maxTranslate);
    };

    const animate = () => {
      if (scrollWrapperRef.current) {
        if (state.current.isDesktop) {
          const { targetY, currentY } = state.current;
          state.current.currentY += (targetY - currentY) * SMOOTHING;
          const totalY = INITIAL_OFFSET + state.current.currentY;
          scrollWrapperRef.current.style.transform = `translate3d(0, ${totalY}px, 0)`;
        } else {
          scrollWrapperRef.current.style.transform = `translate3d(0, ${INITIAL_OFFSET}px, 0)`;
        }
      }
      state.current.requestRef = requestAnimationFrame(animate);
    };

    updateDimensions();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", updateDimensions);
    state.current.requestRef = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateDimensions);
      cancelAnimationFrame(state.current.requestRef);
    };
  }, []);

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  return (
    <section 
      {...props} 
      className={outerClasses} 
      ref={heroRef} 
      style={{ 
        overflow: 'hidden', 
        minHeight: '85vh', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}
    >
      <div className="container-sm">
        {/* SCROLL WRAPPER: Handles the parallax movement */}
        <div 
          ref={scrollWrapperRef}
          style={{ 
            willChange: "transform",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            width: '100%'
          }}
        >
          {/* CONTENT: Handles the AOS entrance animations */}
          <div className="hero-content" style={{ zIndex: 2 }}>
            <h1 className="mt-0 mb-16" data-aos="zoom-in" data-aos-duration="2000">
              {t("LivemorebeautifullywithEdmmo")}
              <span className="text-color-primary"> edmmo</span>
            </h1>
            <div className="container-xs">
              <div data-aos="zoom-in" data-aos-duration="2000" data-aos-delay="200">
                <a href="#contact" style={{ display: 'inline-block' }}>
                  <Button color="primary" wideMobile>
                    {t("Let'sgo")}
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;